export default {
    email: {
        required: {value: true, errorMessage: 'Email is required'},
    },
    password: {
        required: {value: true, errorMessage: 'Password is required'},
    }
}
